export default __webpack_public_path__ + "static/media/taiwan.7109858d.jpg";